// extracted by mini-css-extract-plugin
module.exports = {"container":"_3KnYgBN","header":"_38S_tdZ","closeIcon":"_2Zzw8xK","section":"_1UhcipF","error":"_3u__UUS","loginForm":"_3fJYYci","footer":"_1nWWiqS","loading":"_12Waexy"};